import { Button as MuiButton } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";
import React, { forwardRef } from "react";

import { useTranslation } from "react-i18next";

interface Params {
  value: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  style: React.CSSProperties;
}

const Button = styled(MuiButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  margin: "0 10px",

  "&:hover": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.75),
  },
}));

export const CustomButton = forwardRef<HTMLButtonElement, Params>(({ value, onClick }, ref) => {
  const { t } = useTranslation();
  const tRP = "pages.system_settings.tables.tna_calendars"; // tRP - translation root path
  const monthsList: { [key: number]: string } = {
    "0": t(`${tRP}.month_01`),
    "1": t(`${tRP}.month_02`),
    "2": t(`${tRP}.month_03`),
    "3": t(`${tRP}.month_04`),
    "4": t(`${tRP}.month_05`),
    "5": t(`${tRP}.month_06`),
    "6": t(`${tRP}.month_07`),
    "7": t(`${tRP}.month_08`),
    "8": t(`${tRP}.month_09`),
    "9": t(`${tRP}.month_10`),
    "10": t(`${tRP}.month_11`),
    "11": t(`${tRP}.month_12`),
  };

  const splitedValue = value.split("/");
  const month = Number(splitedValue[0]) - 1;
  const year = splitedValue[1];

  return (
    <Button
      variant="contained"
      onClick={onClick}
      ref={ref}
      style={{
        padding: "3px 8px",
      }}
    >
      {`${monthsList[month]} ${year}`}
    </Button>
  );
});

CustomButton.displayName = "CustomButton";
